import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Whether triangle moves are permitted.
 */
export const schema = z.boolean();

export type AllowTriangleMoves = z.infer<typeof schema>;

export const definition = define({
  key: 'allow_triangle_moves',
  schema,
  label: 'Activate Triangle Moves',
  description:
    'Activate/Deactivate the triangle moves feature for clients at this level. Triangle moves allow for price adjustments to a ride-drive-ride bundle of moves.',
  warning: 'If you do not understand what this feature does, please leave it disabled.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
